import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointVerticalNumericComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericComponent';
import KeyPointVerticalNumericFourMobileComponent from '../../components/HomePage/KeyPointVertical/KeyPointVerticalNumericFourMobileComponent';
import keyPointVerticalNumericData from '../../json/components/HomePages/ServicePlans/keyPointVerticalNumericData.json';

import SeoSnakeGuideComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideComponent';
import SeoSnakeGuideMobileComponent from '../../components/HomePage/SeoSnakeGuide/SeoSnakeGuideMobileComponent';
import snakeGuideData from '../../json/components/HomePages/ServicePlans/snakeGuideData.json';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/ServicePlans/partnerBrandsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/ServicePlans/fourBlogCardsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/ServicePlans/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/ServicePlans/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsDataAll from '../../json/components/HomePages/ServicePlans/scrollingCardsAllData.json';
import scrollingCardsData from '../../json/components/HomePages/ServicePlans/scrollingCardsData.json';

import ThreeColumnCardComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardComponent';
import ThreeColumnCardMobileComponent from '../../components/HomePage/ThreeColumnCard/ThreeColumnCardMobileComponent';
import threeColumnCardData from '../../json/components/HomePages/ServicePlans/threeColumnCardData.json';

import SectionStepsComponent from '../../components/HomePage/SectionSteps/SectionStepsComponent';
import SectionStepsMobileComponent from '../../components/HomePage/SectionSteps/SectionStepsMobileComponent';
import sectionStepsData from '../../json/components/HomePages/ServicePlans/sectionStepsData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function ServicePlansPage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/service-plan-quotes/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestServicePlanQuotes_CrossSell"
        fallbackKey="latestServicePlansQuotes"
        navigateTo="/service-plan-quotes/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointVerticalNumericComponent
            data={keyPointVerticalNumericData}
          />
        ) : (
          <KeyPointVerticalNumericFourMobileComponent
            data={keyPointVerticalNumericData}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Your car deserves a little TLC'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Your car deserves a little TLC'}
            color={'blue'}
            buttonText={'Compare now'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SeoSnakeGuideComponent data={snakeGuideData} />
        ) : (
          <SeoSnakeGuideMobileComponent data={snakeGuideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ThreeColumnCardComponent data={threeColumnCardData} />
        ) : (
          <ThreeColumnCardMobileComponent data={threeColumnCardData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <SectionStepsComponent data={sectionStepsData} />
        ) : (
          <SectionStepsMobileComponent data={sectionStepsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsData} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Dunno if that rattling sound is getting worse?'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsUp'}
            title={'Dunno if that rattling sound is getting worse?'}
            color={'blue'}
            buttonText={'Ask Hippo'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent data={fourBlogCardsData} tag="motor" />
        ) : (
          <FourBlogCardsMobileComponent data={fourBlogCardsData} tag="motor" />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataAll} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataAll} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default ServicePlansPage;
